import { Directive, ElementRef, HostListener } from '@angular/core';
import { UtilService } from '../services/util.service';

@Directive({
  selector: '[appTwoDigitDecimalNumber]'
})
export class TwoDigitDecimalNumberDirective {

  decimal_points: any

  // Allow decimal numbers and negative values

  private regexWithComma: RegExp = new RegExp(/^[0-9]{1,4}[,]?(\d{1,2})?$/g);
  private regexWithDecimal: RegExp = new RegExp(/^[0-9]{1,4}[.]?(\d{1,2})?$/g);
  private regex;
  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', '-', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];

  constructor(private el: ElementRef, private utilService: UtilService) {

    this.utilService.isCurrencyValidation() ? this.regex = this.regexWithDecimal : this.regex = this.regexWithComma;

  }
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {

    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    let current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const positionEnd = this.el.nativeElement.selectionEnd;
    const next: string = [current.slice(0, position), event.key == 'Decimal' ? ',' : event.key, current.slice(positionEnd)].join('');

    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }

}
